<script setup>
  import { onMounted } from "vue";
  import TwoPanePage from "@templates/TwoPanePage.vue";
  import MGroupList from "@/components/MCampaign/MGroupList.vue";
  import MGroupEdit from "@/components/MCampaign/MGroupEdit.vue";
  import { useMGroupsStore } from "@stores/mGroups";
  import { useUnsavedChangesGuard } from "@/utils/composables/useUnsavedChangesGuard";
  import { useMCampaignUnsavedChanges } from "@/utils/composables/useMCampaignUnsavedChanges";

  const { cleanMGroups, selectMGroup } = useMGroupsStore();

  useUnsavedChangesGuard(useMCampaignUnsavedChanges().hasUnsavedChanges);

  onMounted(() => {
    cleanMGroups();
    selectMGroup(0);
  });
</script>

<template>
  <TwoPanePage data-cy="master-campaign-ads-page">
    <template #left>
      <MGroupList />
    </template>
    <template #right>
      <MGroupEdit />
    </template>
  </TwoPanePage>
</template>
